import React, { useState, useEffect } from "react";
import SentimentTag from "./SentimentTag";
import "./PostSentimentContainer.css";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";
import { useNavigate, Link } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";
import { hot_colors, cool_colors, neutral_colors } from "../constants";

function PostSentimentContainer(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const [isTagChanged, setIsTagChaged] = useState(false);
    const { metaSourceName } = props.settings;
    const settings = props.settings;
    const user = props.user;

    // const { tagData } = props.settings;
    const { sentimentPostIdData } = props.settings;
    const sentimentScore = props.sentimentScore;

    function updateTagData(sentimentPostIdData) {
        const tagDataObject = JSON.parse(sentimentPostIdData);
        let tagDataString = JSON.stringify(tagDataObject);
        const tagArr = Object.values(tagDataObject);
        console.log(tagArr);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(tagDataString, "sentimentPostIdData");
            record.setValue(tagArr, "selectedSentimentPostIds");
            record.setValue("{}", "sentimentPostIdData");
        });
    }

    function onFindArticlesClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("Trending topics from ", "metaDescription");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue(false, "isRightNavActivated");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedLeads");
        });
        updateTagData(sentimentPostIdData);
        navigate("/trending");
    }

    function onFeedgramAnalysisLinkClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "sentimentPostIdData");
        });
        navigate("/terms");
    }

    useEffect(() => {
        if (sentimentPostIdData == "{}") {
            setIsTagChaged(false);
        } else {
            setIsTagChaged(true);
        }
    }, [sentimentPostIdData]);

    function ColorBox(props) {
        return (
            <div
                style={{
                    backgroundColor: props.color,
                    marginRight: "10px",
                    width: "15px",
                    height: "15px",
                    borderRadius: "1000px",
                }}
            ></div>
        );
    }

    return (
        <div className="sentiment-container">
            <div className={`find-trending-articles-sentiment`}>
                <div className={`tag-container-info`}>
                    <h3> {metaSourceName}</h3>
                </div>
                <button
                    disabled={!isTagChanged}
                    className={`btn-find-articles-topics btn-find-articles-${isTagChanged}`}
                    onClick={onFindArticlesClick}
                >
                    {" "}
                    Go to Articles {" "}
                </button>
            </div>
            <div className="info-wrapper">
                <div className="color-box-container">
                    <span>
                        {" "}
                        <ColorBox color={cool_colors["purple000"]} /> More
                        Positive{" "}
                    </span>

                    <span>
                        {" "}
                        <ColorBox
                            color={cool_colors["green000"]}
                        /> Positive{" "}
                    </span>

                    <span>
                        {" "}
                        <ColorBox color={neutral_colors["gray"]} /> Neutral{" "}
                    </span>

                    <span>
                        {" "}
                        <ColorBox
                            color={hot_colors["yellow300"]}
                        /> Negative{" "}
                    </span>
                    <span>
                        {" "}
                        <ColorBox color={hot_colors["red300"]} /> More Negative{" "}
                    </span>
                </div>

                <span>
                    <small>
                        &#128161; Select one or more posts and tap Read Posts.{" "}
                        <a href="#"> Know More </a>
                    </small>
                </span>
            </div>
            <div className="sentiment-box">
                <div></div>
                {props.sentimentScore.map((value, key) => (
                    <div key={key}>
                        <SentimentTag
                            className={`xxxx`}
                            id={key}
                            value={value["postTitle"]}
                            sentiment={value["sentiment"]}
                            postId={value["postId"]}
                            postReleased={value["postReleased"]}
                            settings={settings}
                            user={user}
                        />
                    </div>
                ))}
            </div>

            <p className={`analyse-short-description`}>
                Generated with{" "}
                <Link
                    target="_blank"
                    className={`feedgram-link`}
                    to="/topic-analysis"
                >
                    Feedgram Anvanced Topic Analysis.
                </Link>
            </p>
        </div>
    );
}

export default PostSentimentContainer;
